import React, { FunctionComponent } from "react";

import SurveyModal from "src/components/survey/SurveyModal";
import SurveyButton from "src/components/survey/SurveyButton";

import { getDateStringFromDateString, getTimeStringFromDateString } from "src/_core/utils/dateUtils/dateUtils";

import "./styles.scss";

export type SurveyActiveModalProps = {
  isOpen: boolean;
  onClose: () => void;
  startDate: string;
  endDate: string;
  startDay: string;
  frequency: number;
};

export const SurveyActiveModal: FunctionComponent<SurveyActiveModalProps> = ({
  isOpen = false,
  onClose,
  startDate,
  endDate,
  startDay,
  frequency
}) => {
  const scheduledText = (frequencyValue: number) => {
    let frequencyText: string;
    switch (frequencyValue) {
      case 1: {
        frequencyText = ` will start, ${getDateStringFromDateString(startDate)} at 
        ${getTimeStringFromDateString(startDate)}. Survey will end 
        on ${getDateStringFromDateString(endDate)} at ${getTimeStringFromDateString(endDate)}.`;
        break;
      }
      case 2: {
        frequencyText = ` will start, ${getDateStringFromDateString(startDate)} at 
        ${getTimeStringFromDateString(startDate)}. Survey will repeat daily and end on ${getDateStringFromDateString(endDate)} 
        at ${getTimeStringFromDateString(endDate)}.`;
        break;
      }
      case 3: {
        frequencyText = ` will start, ${getDateStringFromDateString(startDate)} at 
        ${getTimeStringFromDateString(startDate)}. Survey will repeat weekly on ${startDay} and end 
        on ${getDateStringFromDateString(endDate)} at ${getTimeStringFromDateString(endDate)}.`;
        break;
      }
      default:
        frequencyText = " is now scheduled";
        break;
    }
    return frequencyText;
  };

  return (
    <SurveyModal isOpen={isOpen} onClose={onClose}>
      <div className="survey-active-modal">
        <h1>Your Survey is Now Active!</h1>
        <img src={require("../../assets/images/graphics/survey-active-modal.png")} alt="survey active art" />
        <h4 className="mb30">
          <b>Overall Wellbeing Check-In Survey</b>
          {scheduledText(frequency)}
        </h4>
        <SurveyButton
          label="Close"
          onClick={() => {
            onClose();
          }}
        />
      </div>
    </SurveyModal>
  );
};

export default SurveyActiveModal;
